import { sessionSetItem, sessionGetItem } from '@/utils';

const allMenus = [];

class OpenMenus {
  menus = [];

  setOpenMenus(nextRoute) {
    const current = this.menus.find(menu => menu.name === nextRoute.name);
    if (!current) {
      const menuItem = {
        fullPath: nextRoute.fullPath,
        name: nextRoute.name,
        pageTitle: nextRoute.meta.pageTitle,
        auth: nextRoute.meta.auth,
      };
      this.menus = this.menus.concat([menuItem]);
    } else {
      current.fullPath = nextRoute.fullPath;
    }
    sessionSetItem('openMenus', JSON.stringify(this.menus));
  }

  removeOpenMenus(closeMenus) {
    this.menus = this.menus.filter(menu => closeMenus.indexOf(menu) === -1);
    sessionSetItem('openMenus', JSON.stringify(this.menus));
  }
}

export const openMenus = new OpenMenus();

export const initMenus = pageRoutes => {
  allMenus.splice(0);
  pageRoutes.forEach(moduleMenu => {
    if (moduleMenu.children.length) {
      moduleMenu.children.forEach(menu => {
        allMenus.push(menu);
      });
    }
  });
  try {
    const cacheMenus = sessionGetItem('openMenus') || [];
    openMenus.menus = cacheMenus.filter(cm => allMenus.find(menu => menu.name === cm.name));
  } catch {
    console.log('openMenus cache parse error');
    sessionSetItem('openMenus', '[]');
    openMenus.menus = [];
  }
  sessionSetItem('openMenus', JSON.stringify(openMenus.menus));
};
